import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuth: false,
  userName: "",
  dateClasses: "",
  codeReg: "",
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    checkAuth(state, action) {
      state.isAuth = action.payload;
    },
    setUserName(state, action) {
      state.userName = action.payload;
    },
    setDateClasses(state, action) {
      state.dateClasses = action.payload;
    },
    checkCodeReg(state, action) {
      state.codeReg = action.payload;
    },
    logout(state) {
      state.isAuth = false;
      state.userName = "";
      state.dateClasses = "";
      state.codeReg = "";
    },
  },
});

export const { checkAuth, setUserName, setDateClasses, checkCodeReg, logout } = authSlice.actions;

export default authSlice.reducer;
